var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.949219,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.949219,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 16.9492C16.2165 16.9492 17 16.1657 17 15.1992C17 14.2327 16.2165 13.4492 15.25 13.4492C14.2835 13.4492 13.5 14.2327 13.5 15.1992C13.5 16.1657 14.2835 16.9492 15.25 16.9492Z",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 18.9492C8.2165 18.9492 9 18.1657 9 17.1992C9 16.2327 8.2165 15.4492 7.25 15.4492C6.2835 15.4492 5.5 16.2327 5.5 17.1992C5.5 18.1657 6.2835 18.9492 7.25 18.9492Z",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.1992V8.44922L17 6.44922V15.1992",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audio_icon.f51b6d43ebd571bda58a09833e59cdaf.svg";
export { ForwardRef as ReactComponent };